<doka-search-field
  [formControl]="searchTextControl"
  [placeholder]="placeholderKey | translate"></doka-search-field>
